import Repository from "../axios";

const resource = "/customer/product-order/invoice-list";

export default {
  getListOfAllInvoices(
    pageNumber = 1,
    filterQuery,
    pagination = defaultPagination
  ) {
    return Repository.get(
      `${resource}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`
    );
  },
  getProductOrderInvoiceData(secret_code) {
    return Repository.get(`/customer/product-order/${secret_code}/pdf-data`)
  },
};
